window.lang2 =
{
  "general": {
    "meta": {
      "tags": "Tags \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "404": {
      "title": "404 - Page not found",
      "subtext_html": "This page is not available. <a href=\"\/collections\/all\">Return to shopping<\/a>"
    },
    "breadcrumbs": {
      "home": "Home",
      "home_link_title": "Back to the homepage"
    },
    "newsletter_form": {
      "title": "Newsletter",
      "newsletter_email": "Email address",
      "submit": "Submit",
      "text": "Enter your email address",
      "noitice": "Don’t show this popup again",
      "go": "Go",
      "ok": "OK",
      "subscribe": "Subscribe"
    },
    "search": {
      "no_results_html": "Search results for \"{{ terms }}\"",
      "results_for_html": "Search results for \"{{ terms }}\"",
      "title": "Search",
      "placeholder": "Search...",
      "submit": "Search",
      "category": "Select category",
      "info_search": "Start typing to see products you are looking for.",
      "not_found": "No products found",
      "view_results": "View all results"
    },
    "date": {
      "year_text": "years",
      "month_text": "months",
      "week_text": "weeks",
      "day_text": "days",
      "year_singular_text": "year",
      "month_singular_text": "month",
      "week_singular_text": "week",
      "day_singular_text": "day",
      "hour_text": "Hours",
      "min_text": "Mins",
      "sec_text": "Secs",
      "hour_singular_text": "Hour",
      "min_singular_text": "Min",
      "sec_singular_text": "Sec"
    },
    "modal": {
      "wishlist_text": "Excl. shipping",
      "continue_shopping": "Continue",
      "go_to_wishlist": "My wishlist",
      "add_to_wishlist_message": "You have just added to your wishlist:",
      "cart_text": "Excl. shipping",
      "go_to_cart": "Go to cart",
      "add_to_cart_message": "You have just added this item to your cart:",
      "qty": "Quantity:",
      "total": "Total:"
    }
  },
  "header": {
    "settings": {
      "login": "Log in or create an account",
      "register": "Register",
      "logout": "Log out",
      "my_account": "My account",
      "wishlist": "My wishlist",
      "compare": "Compare",
      "currency": "Currency",
      "newsletter_signup": "Newsletter sign-up",
      "language": "Languages",
      "daily_deal": "Daily deal",
      "blog": "Blog",
      "links": "Links",
      "shop": "Shop"
    },
    "topbar": {
      "my_cart": "My cart",
      "search": "Search"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "{{ date }}",
      "by_admin": "By {{ author }}",
      "older_post": "Previous post",
      "newer_post": "Next post",
      "tags": "Tags",
      "read_more": "Read more",
      "share_post": "Share this post"
    },
    "comments": {
      "title": "Leave a comment",
      "name": "Name *",
      "email": "Email *",
      "message": "Message *",
      "post": "Post comment",
      "moderated": "Please note that comments must be approved before being displayed",
      "success_moderated": "Your comment was submitted successfully. We’ll publish it shortly after our moderation process.",
      "success": "Your comment was posted successfully!",
      "comments_with_count": {
        "one": "{{ count }} comment",
        "other": "comments ({{ count }})"
      }
    },
    "sidebar": {
      "recent_articles": "Recent posts",
      "categories": "Categories",
      "video": "Latest video",
      "tags": "Tag cloud",
      "search_placeholder": "Search posts here"
    }
  },
  "cart": {
    "general": {
      "title": "Cart",
      "remove": "Remove",
      "edit": "Edit",
      "note": "Special instructions for order",
      "carttotals": "Cart totals",
      "subtotal": "Subtotal",
      "grandtotal": "Total",
      "shipping_at_checkout": "Checkout with multiple addresses",
      "update": "Update cart",
      "continue": "Continue shopping",
      "checkout": "Proceed to checkout",
      "empty": "Your cart is empty.",
      "continue_browsing_html": "<a href=\"\/collections\/all\">Return to shopping<\/a>.",
      "close_cart": "Close cart",
      "shipping_calculator_error_message": "Error: Please enter correct shipping information",
      "shipping_calculator_success_many_rates": {
        "there_are": "There are",
        "shipping_rates_available_for": "shipping rates available for",
        "starting_at": ", starting at"
      },
      "shipping_calculator_success_one_rate": "There is one shipping rate available for this order",
      "shipping_calculator_success_no_rate": "There are no shipping rates available for this order and shipping destination.",
      "shipping_calculator_success_at": "at"
    },
    "header": {
      "checkout": "Checkout",
      "total": "Total:",
      "total_numb": "item(s)",
      "no_item": "There are no items in your cart.",
      "remove_this_item": "Remove item"
    },
    "label": {
      "product": "Product name",
      "price": "Unit price",
      "quantity": "Qty",
      "update_cart": "Update Cart",
      "remove": "Remove",
      "total": "Total"
    },
    "shipping": {
      "title": "Estimate shipping and taxes.",
      "title_form": "Enter your destination to get a shipping estimate.",
      "country": "Country",
      "state": "State",
      "zip": "ZIP\/Postal code",
      "submit_button": "Get a quote",
      "submit_button_when_calculating": "Calculating..."
    }
  },
  "collections": {
    "general": {
      "title": "Collections list",
      "all_of_collection": "All",
      "no_matches": "No products match your search.",
      "link_title": "View the {{ title }} collection",
      "grid_view": "Grid",
      "list_view": "List",
      "shop_the_collection": "Shop the collection",
      "items_with_count": {
        "one": "{{ count }} product",
        "other": "{{ count }} products"
      },
      "clear": "Clear",
      "refine_by": "Refine by",
      "clear_all": "Clear all",
      "filter": "Filter",
      "showing": "Showing",
      "of": "of",
      "previous": "Previous",
      "next": "Next",
      "show_more": "Load more",
      "loading": "Loading",
      "no_more_product": "No more products",
      "quickview": "Quick View"
    },
    "sidebar": {
      "categories": "Categories",
      "shopby": "Shop by",
      "tags": "Filters"
    },
    "sorting": {
      "title": "Sort by:",
      "featured": "Featured",
      "best_selling": "Best selling",
      "az": "A-Z",
      "za": "Z-A",
      "price_ascending": "Price: low to high",
      "price_descending": "Price: high to low",
      "date_descending": "Date: new to old",
      "date_ascending": "Date: old to new",
      "limit_16": "16",
      "limit_22": "22",
      "limit_44": "44",
      "limit_all": "All"
    },
    "limiter": {
      "title": "Show:",
      "limit_16": "16",
      "limit_22": "22",
      "limit_44": "44",
      "limit_all": "All"
    },
    "onboarding": {
      "modal_title": "This page will display all products in your store",
      "no_products_html": "There are no products yet, but as soon as you start adding them, they will appear here—whether they’re in a collection or not.",
      "add_product": "Add a product"
    },
    "onepage": {
      "seemore": "See more"
    }
  },
  "contact": {
    "form": {
      "title": "Leave a ",
      "title_after": "Message",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "comment": "Comment",
      "send": "Send message",
      "submit": "Submit",
      "post_success": "Thanks for contacting us. We’ll get back to you as soon as possible."
    }
  },
  "customer": {
    "account": {
      "title": "My account",
      "details": "Account details",
      "view_addresses": "View addresses",
      "return": "Return to account details"
    },
    "activate_account": {
      "title": "Activate account",
      "subtext": "Create your password to activate your account.",
      "submit": "Activate account",
      "cancel": "Decline invitation",
      "password": "Password",
      "password_confirm": "Confirm password"
    },
    "addresses": {
      "title": "Your address",
      "default": "Default",
      "add_new": "Add a new address",
      "edit_address": "Edit address",
      "first_name": "First name",
      "last_name": "Last name",
      "company": "Company",
      "address1": "Address 1",
      "address2": "Address 2",
      "city": "City",
      "country": "Country",
      "province": "Province",
      "zip": "Postal code",
      "phone": "Phone",
      "set_default": "Set as default address",
      "add": "Add address",
      "update": "Update address",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "delete_message": "Are you sure you want to delete this address?"
    },
    "login": {
      "heading": "Log in or create an account",
      "page_title": "Login",
      "title": "Registered customers",
      "content": "If you have an account with us, please log in.",
      "email": "Email address",
      "password": "Password",
      "forgot_password": "Forgot your password?",
      "sign_in": "Sign in",
      "log_in": "Login",
      "cancel": "Return to shop",
      "guest_title": "Continue as a guest",
      "guest_continue": "Continue",
      "register": "New customers",
      "register_content": "By creating an account with our store, you’ll be able to check out faster, store multiple shipping addresses, view and track your orders in your account, and more.",
      "register_button": "Create an account"
    },
    "logout": {
      "title": "Log out"
    },
    "orders": {
      "title": "Order history",
      "order_number": "Order",
      "date": "Date",
      "payment_status": "Payment status",
      "fulfillment_status": "Fulfillment status",
      "total": "Total",
      "none": "You haven’t placed any orders yet."
    },
    "order": {
      "title": "Order {{ name }}",
      "date": "Placed on {{ date }}",
      "cancelled": "Order cancelled on {{ date }}",
      "cancelled_reason": "Reason: {{ reason }}",
      "billing_address": "Billing address",
      "payment_status": "Payment status",
      "shipping_address": "Shipping address",
      "fulfillment_status": "Fulfillment status",
      "discount": "Discount applied",
      "shipping": "Shipping",
      "tax": "Taxes",
      "product": "Product",
      "sku": "SKU",
      "price": "Price",
      "quantity": "Quantity",
      "total": "Total",
      "fulfilled_at": "Fulfilled on {{ date }}",
      "subtotal": "Subtotal"
    },
    "recover_password": {
      "title": "Reset your password",
      "email": "Email",
      "submit": "Submit",
      "cancel": "Back to login",
      "subtext": "We will send you an email to reset your password.",
      "success": "We’ve sent you an email to reset your password."
    },
    "reset_password": {
      "title": "Reset account password",
      "subtext": "Enter a new password for {{ email }}",
      "submit": "Reset password",
      "password": "Password",
      "password_confirm": "Confirm password"
    },
    "register": {
      "page_title": "Register",
      "title": "Create an account",
      "title_form": "Personal information",
      "first_name": "First name",
      "last_name": "Last name",
      "email": "Email",
      "submit": "Submit",
      "cancel": "Return to shop",
      "required": "* Required fields",
      "password": "Password",
      "message": "Please enter the information below to create your account."
    }
  },
  "homepage": {
    "sections": {
      "frontpage_title": "Frontpage collection",
      "featured_title": "Featured collections",
      "news_title": "Latest news"
    },
    "onboarding": {
      "modal_title": "We’re almost there...",
      "no_products_html": "You don’t have any products in your Frontpage collection. This message will appear until a product is <a href=\"\/admin\/collections?tutorial=Frontpage\">added to this collection<\/a>.",
      "add_product": "Add a product",
      "product_title": "Product title",
      "no_collections_html": "You don’t have any collections to display here. <a href=\"\/admin\/custom_collections\">Add one or more collections<\/a> to complete the default homepage.",
      "add_collection": "Add a collection",
      "collection_title": "Collection title"
    }
  },
  "layout": {
    "navigation": {
      "menu": "Menu"
    },
    "drawers": {
      "browse": "Browse",
      "close_menu": "Close menu"
    },
    "cart": {
      "title": "Cart",
      "items_count": {
        "one": "item",
        "other": "items"
      }
    },
    "customer": {
      "account": "Account",
      "logged_in_as_html": "Logged in as {{ first_name }}",
      "log_out": "Log out",
      "log_in": "Log in",
      "create_account": "Create account"
    },
    "footer": {
      "social_title": "Stay connected",
      "newsletter_title": "Newsletter",
      "accepted_payments": "Accepted payment methods"
    }
  },
  "wish_list": {
    "general": {
      "wishlist": "Wishlist",
      "add_to_wishlist": "Add to wishlist",
      "browse_wishlist": "Browse wishlist",
      "product": "Product",
      "price": "Price",
      "remove": "has removed from wishlist",
      "quantity": "Quantity",
      "options": "Options",
      "no_item": "There are no items in the wishlist box",
      "item_exist": "exists in wishlist",
      "item_added": "successfully added to wishlist"
    }
  },
  "compare_list": {
    "general": {
      "compare": "Compare box",
      "add_to_compare": "Add to compare",
      "price": "Price",
      "product": "Product",
      "remove": "has been removed from compare box",
      "quantity": "Quantity",
      "options": "Options",
      "no_item": "There are no items in the compare box",
      "item_exist": "exists in compare",
      "item_added": "successfully added to compare box",
      "features": "Features",
      "actions": "Actions"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Previous product",
      "next_product_html": "Next product &rarr;",
      "from_text_html": "From {{ price }}",
      "sale_price": "Sale price",
      "regular_price": "Regular price",
      "related_products": "Also bought",
      "sale": "Sale",
      "show_more": "Show more",
      "no_more_product": "No more products",
      "view_all": "View All Products"
    },
    "product": {
      "quickview": "Quick view",
      "sold_out": "Sold out",
      "on_sale": "On sale",
      "on_sale_from_html": "<strong>On sale<\/strong> {{ price }}",
      "unavailable": "Unavailable",
      "compare_at": "Was",
      "quantity": "Qty",
      "add_to_cart": "Add to cart",
      "select_options": "Select Options",
      "tab_title_description": "More information",
      "tab_title_review": "Reviews",
      "share": "Share:",
      "availability": "Availability:",
      "sku": "SKU:",
      "in_stock": "In stock",
      "out_of_stock": "Out of stock",
      "many_in_stock": "Many in stock",
      "product_type": "Product type:",
      "product_vendor": "Vendor:",
      "count_down": "Limited time offer ends in:"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Your {{ shop }} gift card is worth {{ value }}!",
      "subtext": "Here is your gift card!",
      "disabled": "Disabled",
      "expired": "Expired on {{ expiry }}",
      "active": "Expires on {{ expiry }}",
      "redeem": "Enter this code at checkout to use your gift card",
      "shop_link": "Shop",
      "print": "Print"
    }
  },
  "date_formats": {
    "month_day_year": "%d %B, %Y"
  }
}
